import { z } from 'zod';
import { baseModelSchema } from '../../../model/baseModel';
import { IUnitOfMeasureTypeFormValues } from './unitOfMeasureTypeFormValues';

/**
 * Zod schema for validating unit of measure type data.
 * Extends the base model schema with unit of measure type-specific fields.
 *
 * @property {string} name - Name of the unit of measure type (max 255 characters)
 */
export const unitOfMeasureTypeSchema = baseModelSchema.extend({
    name: z.string().nonempty('Name is required').max(255, 'Name can only be up to 255 characters long.'),
});

/**
 * TypeScript interface representing a Unit of Measure Type object.
 * Generated from the Zod schema for type safety.
 */
export type IUnitOfMeasureType = z.infer<typeof unitOfMeasureTypeSchema>;

export function UnitOfMeasureType(formValues : IUnitOfMeasureTypeFormValues) : IUnitOfMeasureType {
    return unitOfMeasureTypeSchema.parse({
        ...formValues,
    });
};
